(function () {
    "use strict";

    angular.module("angular.emlpayments")
        .filter("yesNo", [function () {
            return function (input) {
                return input ? "GLOBAL.YES_TEXT" : "GLOBAL.NO_TEXT";
            };
        }]);
}());